// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"ffc7cdbf","236":"c347e117","301":"49eeee63","442":"74e83723","705":"77d948dd","792":"abec7910"}[chunkId] + ".js";
};